export default function WhatWeDo() {
  const pillars = [
    {
      icon: 'ri-megaphone-line',
      title: 'Acquisition',
      subtitle: 'Attirez les bons prospects',
      description: 'Publicités ciblées, SEO et contenus à forte valeur pour générer un trafic qualifié en continu.',
      color: 'from-orange-500 to-orange-600',
    },
    {
      icon: 'ri-exchange-line',
      title: 'Transformation',
      subtitle: 'Convertissez vos visiteurs en leads',
      description: 'Tunnels de conversion, formulaires et offres optimisés pour maximiser chaque visite.',
      color: 'from-teal-500 to-teal-600',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Suivi & Automatisations',
      subtitle: 'Relancez et qualifiez automatiquement',
      description: 'WhatsApp, emails automatisés et lead scoring pour ne perdre aucun prospect.',
      color: 'from-emerald-500 to-emerald-600',
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-white overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <header className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            <strong></strong><span style={{ fontSize: '3rem' }}>Le triangle de la génération de leads</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trois piliers pour transformer votre présence digitale en <strong>machine à rendez-vous qualifiés</strong>
          </p>
        </header>

        {/* Triangle Image */}
        <div className="flex justify-center mb-12 sm:mb-16 w-full">
          <img
            src="https://static.readdy.ai/image/857147547f7da499a0fc7d35aaf6d8ec/369169858391afe5cffecd2d29b86abf.jpeg"
            alt="Le triangle de la réussite - Génération de Leads"
            className="w-full max-w-2xl h-auto object-top rounded-xl"
          />
        </div>

        {/* Pillars Grid */}
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
          {pillars.map((pillar, index) => (
            <article
              key={index}
              className="group relative bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:-translate-y-2"
            >
              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${pillar.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${pillar.icon} text-2xl text-white`} aria-hidden="true"></i>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-1">
                {pillar.title}
              </h3>
              <p className="text-orange-600 font-semibold mb-3 text-sm">
                {pillar.subtitle}
              </p>
              <p className="text-gray-500 leading-relaxed text-sm">
                {pillar.description}
              </p>

              <div className="absolute top-6 right-6 w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 font-bold group-hover:bg-gradient-to-br group-hover:from-orange-500 group-hover:to-orange-600 group-hover:text-white transition-all duration-300">
                {index + 1}
              </div>
            </article>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-50 to-teal-50 px-8 py-4 rounded-full border border-orange-200">
            <i className="ri-trophy-line text-xl text-orange-600 flex-shrink-0" aria-hidden="true"></i>
            <span className="font-semibold text-gray-900 text-sm">
              Une approche complète pour des <strong>résultats durables</strong>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
